export const roleOptions = [
    { value: 'ADMIN', label: 'ADMIN' },
    { value: 'USER', label: 'USER' },
    { value: 'GUEST', label: 'GUEST' },
];

export const statusOptions = [
    { value: 'ACTIVE', label: 'Activo' },
    { value: 'INACTIVE', label: 'Inactivo' },
];

export const defaultCreateFormState = {
    firstName: '',
    lastName: '',
    email: '',
    role: 'USER',
};

export const defaultEditFormState = {
    firstName: '',
    lastName: '',
    email: '',
    role: 'USER',
    password: '',
    active: true,
};
